import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Form, Menu, Modal, Row } from 'antd'
import Button from 'components/Button'
import deleteIcon from 'components/Images/OBJECTS.png'
import duplicateIcon from 'components/Images/duplicate.png'
import InfoCards from 'components/InfoCards'
import SucessfullPopup from 'components/UIComponents/CloseRolePopup/SucessfullModelPopup'
import PlusIcon from 'components/icons/PlusIcon'
import SuccessIcon from 'components/icons/SubmitCloseIcon'
import UserBlockIcon from 'components/icons/UserBlockIcon'
import UserDefaultIcon from 'components/icons/UserDefaultIcon'
import { InstituteData } from 'modules/Auth/actions'
import AddNewStudentDrawer from 'modules/Students/Partials/AddNewStudentDrawer'
import SettingsDrawer from 'modules/Students/Partials/SettingsDrawer'
import StudentsBulkUpload from 'modules/Students/Partials/StudentsBulkUpload'
import StudentsInfoTable from 'modules/Students/Partials/StudentsInfoTable'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { COLORS } from 'theme'
import instRequest from 'utils/instRequest'
import CloseRoleDrawer from '../../components/UIComponents/CloseRolePopup'
import PopUpPageIcon from '../../components/icons/PopUpPageIcon'
import UserRestrictedIcon from '../../components/icons/UserRestrictedIcon'
import { singlePdf, zipFile } from '../../utils/downloadFile'
import { permittedEventCruds } from '../../utils/permissionsValidation'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  ActionBarWrapper,
  ButtonDiv,
  CardRow,
  ModalContent,
  ModalOverlay,
  ModalText,
  SectionWrapper,
  SelectAllFlex,
  ShortListModalImg,
  TopHeader,
  TopHeading,
  TopRightFlex,
} from './Style/style'

const ConfirmationModal = ({ onClose, children }) => {
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>{children}</ModalContent>
    </ModalOverlay>
  )
}

const { confirm } = Modal

const Students = ({
  studentsList,
  getStudentsListData,
  createStudent,
  getSingleStudentData,
  singleStudentData,
  deleteStudent,
  editStudent,
  studentsMetrics,
  degreeList,
  blacklistStudent,
  activeInactivateStatus,
  deleteBulkStudents,
  reInviteStudent,
  getDegreeData,
  bulkUploadStudents,
  permissions,
  getNotificationCatalogues,
  notificationCatalogues,
  sendNotificationEmail,
  SelectUnRestricted,
  SelectBlacklist,
  // payload,
  instituteCampusId,
  getConsentDrawerList,
  getJobRolePreview,
  getPlacementHistoryList,
  getStudentPlacedList,
  getPreview,
  bulkReInviteStudent,
  SelectOptOutlist,
  getStudentsListResume,
  resumeBulkDownload,
  ...props
}) => {
  
  const navigate = useNavigate()

  const handleEditFullProfile = () => {
    if (!currentStudentId) return
    navigate(`/tpoApproval/student-resume/${currentStudentId}`)
  }
  
  const object = useRef()
  const [createEditForm] = Form.useForm()
  const location = useLocation() 
  const tabs = [
    {
      value: 'Opt-ed out students',
      label: 'Opt-ed out students',
      count: studentsMetrics?.optOut_list_count ?? 0,
      query: 'optedStatus=opt-out',
    },
    {
      value: 'Pending TPO approval',
      label: 'Pending TPO approval(Opting out)',
      count: studentsMetrics?.optOut_pending ?? 0,
      query: 'optedStatus=opt-out-pending',
    },
    {
      value: 'ending TPO approval',
      label: 'Pending TPO approval(Re-opting in)',
      count: studentsMetrics?.optIn_pending ?? 0,
      query: 'optedStatus=opt-in-pending',
    },
  ]
  const [tabsData, setTabsData] = useState(tabs[0]?.query)
  const defaultCardsData = [
    {
      key: 1,
      icon: <UserDefaultIcon />,
      text: 'Active Students',
      value: '',
      filter: 'status=2',
      isSelected: false,
    },
    {
      key: 2,
      icon: <UserDefaultIcon />,
      text: 'Inactive Students',
      value: '',
      filter: 'status=-2',
      isSelected: false,
    },
    {
      key: 3,
      icon: <UserDefaultIcon />,
      text: 'Incomplete Profile',
      value: '',
      filter: 'completionStart=0&completionEnd=99',
      isSelected: false,
    },
    {
      key: 4,
      icon: <UserDefaultIcon />,
      text: 'Opt-ed Out',
      value: '',
      filter: tabsData,
      isSelected: false,
    },
    {
      key: 5,
      icon: <UserDefaultIcon />,
      text: 'Passed Out',
      value: '',
      filter: `passedOut=true`,
      isSelected: false,
    },
    {
      key: 6,
      icon: <UserRestrictedIcon />,
      text: 'Restricted Students',
      value: '',
      filter: 'isRestricted=true',
      isSelected: false,
    },
    {
      key: 7,
      icon: <UserBlockIcon />,
      text: 'Blacklisted',
      value: '',
      filter: 'status=-1',
      isSelected: false,
    },
  ]
  const { userData, instituteDetails } = useSelector(state => state.auth)
  const [cardsData, setCardsData] = useState(defaultCardsData)
  const [newStudentDrawer, setNewStudentDrawer] = useState(false)
  const [settingDrawer, setSettingDrawer] = useState(false)
  const [uploadDrawer, setUploadDrawer] = useState(false)
  const [statusDrawer, setStatusDrawer] = useState(false)
  const [isEditingForm, setIsEditingForm] = useState(false)
  const [loading, setLoading] = useState(false)
  const [currentStudentId, setCurrentStudentId] = useState('')
  const [countryCode, setCountryCode] = useState('+91')
  const [eventId, setEventId] = useState('')
  const [studentType, setStudentType] = useState('')
  const [studentDOB, setStudentDOB] = useState('')
  const [cardNumber, setCardNumber] = useState(null)
  const [studentBatch, setStudentBatch] = useState({
    startedOn: '',
    endedOn: '',
  })
  const [selected, setSelected] = useState('Opt-ed out students')
  const [search, setSearch] = useState('')

  const [marksType, setMarksType] = useState('')
  const [specialization, setSpecialization] = useState([])

  const [urlQuery, setUrlQuery] = useState('')
  const [sortQuery, setSortQuery] = useState('')
  const [filterData, setFilterData] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)
  const [selectedStudents, setSelectedStudents] = useState([])
  const [selectedUniqueStudents, setSelectedUniqueStudents] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const [courseId, setCourseId] = useState('')
  const [batchValue, setBatchValue] = useState([])
  const [rangeValue, setRangeValue] = useState([])

  const dateFormat = 'DD/MM/YYYY'

  const dispatch = useDispatch()
  const instituteData = useSelector(state => state.auth.instituteDetails)
  const instituteId = useSelector(state => state.auth.instituteCampusId)
  const [matchingTemplate, setMatchingTemplate] = useState(null)
  const [newUrlQuery, setNewUrlQuery] = useState('')
  const [counter, setCounter] = useState(0)
  const [checkHeaderData, setCheckHeaderData] = useState(false)
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)
  const [bulkDownload, setBulkDownload] = useState(false)
  const [popUp, setPopUp] = useState(false)
  const [studentListId, setStudentListId] = useState([])
  const [emailPopUp, setEmailPopUp] = useState(false);
  const [checkedDegreeData , setCheckedDegreeData] = useState([])
  const accessLevel = instituteDetails?.instituteSubscription?.accessLevel
  const [gender,setGender] = useState('')
  const [urlParamsProcessed, setUrlParamsProcessed] = useState(false)
  const hasAppliedDeepLink = useRef(false)
  useEffect(() => {
    if (hasAppliedDeepLink.current) return
    if (!location.search || !cardsData.length) return

    const params = new URLSearchParams(location.search)
    const optedStatus = params.get('optedStatus')
    const isRestricted = params.get('isRestricted')

    if (!optedStatus && !isRestricted) {
      setUrlParamsProcessed(true)
      return
    }

    const queryString = optedStatus
      ? `optedStatus=${optedStatus}`
      : `isRestricted=${isRestricted}`

    const matchingCard = cardsData.find(card => card.filter === queryString)

    if (matchingCard) {
      hasAppliedDeepLink.current = true
      applyCardFilter(matchingCard)
      setTabsData(queryString)
      setSelected('Opt-ed out students')
    }
    setUrlParamsProcessed(true)
  }, [location.search, cardsData])

  useEffect(() => {
    getInstituteDetails()
  }, [])

  const roles = useSelector(state => state?.auth?.userRoleList)
  const roleNames = ['TPO', 'TPO Requests']
  const filteredRoleIds = roles
    ?.filter(role => roleNames.includes(role.name))
    .map(role => role.id)

  useEffect(() => {
    if (instituteData.id) getDegreeData('getAllCourses=true')
  }, [instituteData])

  useEffect(() => {
    // Only wait for URL processing if there are URL parameters to process
    if (location.search && !urlParamsProcessed) return
    if (!Object.keys(instituteData)?.length) return
    if (urlQuery) {
      if (sortQuery) {
        getStudentsListData(
          setLoading,
          `${urlQuery}&pageLimit=10&pageNo=${currentPage}&${sortQuery}`
        )
      } else {
        const urlParams = new URLSearchParams(urlQuery)

        // Extract `startBatch` and `endBatch`
        const startBatch = urlParams.get('startBatch')
        const endBatch = urlParams.get('endBatch')

        let newUrlQuery
        if (startBatch && endBatch) {
          newUrlQuery = urlQuery
        } else {
          const hasOptedOut = Array.from(urlParams.keys()).includes('optedOut')

          if (hasOptedOut) {
            newUrlQuery = `${urlQuery}`
          } else {
            newUrlQuery = Array.from(urlParams.entries())
              .filter(([key]) => key !== 'startBatch' && key !== 'endBatch')
              .map(([key, value]) => `${key}=${value}`)
              .join('&')
          }
        }

        newUrlQuery += `&pageLimit=10&pageNo=${currentPage}`
        getStudentsListData(setLoading, newUrlQuery)
      }
    } else if (sortQuery) {
      getStudentsListData(
        setLoading,
        `pageLimit=10&pageNo=${currentPage}&${sortQuery}`
      )
    } else {
      getStudentsListData(setLoading, `pageLimit=10&pageNo=${currentPage}`)
    }
  }, [urlQuery, currentPage, instituteData, sortQuery, counter, tabsData, urlParamsProcessed])

  const fetchStudentDataList = async () => {
    if (urlQuery) {
      if (sortQuery) {
        const studentData = await getStudentsListResume(
          setLoading,
          `${urlQuery}&pageLimit=10&pageNo=${currentPage}&${sortQuery}&bulkDownload=true`
        )
        setPopUp(true)
        setStudentListId(studentData?.data?.studentIds)
      } else {
        const urlParams = new URLSearchParams(urlQuery)
        const startBatch = urlParams.get('startBatch')
        const endBatch = urlParams.get('endBatch')

        let newUrlQuery
        if (startBatch && endBatch) {
          newUrlQuery = urlQuery
        } else {
          newUrlQuery = Array.from(urlParams.entries())
            .filter(([key]) => key !== 'startBatch' && key !== 'endBatch')
            .map(([key, value]) => `${key}=${value}`)
            .join('&')
        }

        newUrlQuery += `&pageLimit=10&pageNo=${currentPage}&bulkDownload=true`

        const studentData = await getStudentsListResume(setLoading, newUrlQuery)
        setPopUp(true)

        setStudentListId(studentData?.data?.studentIds)
      }
    } else if (sortQuery) {
      const studentData = await getStudentsListResume(
        setLoading,
        `pageLimit=10&pageNo=${currentPage}&${sortQuery}&bulkDownload=true`
      )
      setPopUp(true)
      setStudentListId(studentData?.data?.studentIds)
    } else {
      const studentData = await getStudentsListResume(
        setLoading,
        `pageLimit=10&pageNo=${currentPage}&bulkDownload=true`
      )
      setPopUp(true)
      setStudentListId(studentData?.data?.studentIds)
    }
  }
  useEffect(() => {
    if (bulkDownload) {
      fetchStudentDataList()
    }
  }, [bulkDownload])

  const getInstituteDetails = async () => {
    if (instituteData?.id && instituteId != undefined) return
    try {
      const data = await instRequest.get(`institutes/${instituteId}`)
      if (data?.data?.data?.instituteCampus) {
        let instInfo = {
          ...data?.data?.data?.instituteCampus[0],
          tier: data?.data?.data?.tier,
        }

        dispatch(InstituteData(instInfo))
      }
    } catch (error) {}
  }

  const showConfirm = () => {
    confirm({
      title: 'Do you Want to delete selected students?',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        bulkDelete()
      },
      onCancel() {},
      okText: 'Delete',
    })
  }

  const bulkDelete = () => {
    let studentIds = selectedStudents.map(id => {
      return { id }
    })
    let payLoad = { studentIds }
    deleteBulkStudents(payLoad, urlQuery)
    setCurrentPage(0)
    setSelectedStudents([])
    setSelectedUniqueStudents([])
  }

  useEffect(() => {
    let cardsDataCopy = [...cardsData]
    cardsDataCopy[0].value = studentsMetrics?.active_count
    cardsDataCopy[1].value = studentsMetrics?.inactive_count
    cardsDataCopy[2].value = studentsMetrics?.inComplete_count
    cardsDataCopy[3].value = studentsMetrics?.optOut_count
    cardsDataCopy[4].value = studentsMetrics?.passedOut_count
    cardsDataCopy[5].value = studentsMetrics?.restricted_count
    cardsDataCopy[6].value = studentsMetrics?.blackListed_count
    setCardsData(cardsDataCopy)
  }, [studentsMetrics])

  useEffect(() => {
    if (isEditingForm) {
      let dob = singleStudentData?.studentPersonalProfile?.dob?.trim()

      let mobileCode =
        singleStudentData?.studentPersonalProfile?.phoneNumber?.split(' ')[0]
      setCountryCode(mobileCode)
      setStudentBatch({
        startedOn: singleStudentData?.currentCourse?.startedOn,
        endedOn: singleStudentData?.currentCourse?.endedOn,
      })
      setStudentType(singleStudentData?.currentCourse?.admissionType)
      setMarksType({
        examType: singleStudentData?.currentCourse?.examType,
        duration: singleStudentData?.currentCourse?.duration,
        degreeStreamMapId: singleStudentData?.currentCourse?.degreeStreamMapId,
        type: singleStudentData?.currentCourse?.educationLevel,
      })
      setGender(singleStudentData?.studentPersonalProfile?.gender)
      // Split the comma-separated specialisation and specialisationId strings
      const specialisationNames = singleStudentData?.currentCourse?.specialisation?.split(',') || [];
      const specialisationIds = singleStudentData?.currentCourse?.specialisationId?.split(',') || [];
      
      // Create an array of objects with name and id properties
      const specialisations = specialisationNames.map((name, index) => ({
        name: name.trim(),
        id: specialisationIds[index]?.trim() || ''
      }));
      setSpecialization(specialisations)

      createEditForm.setFieldsValue({
        firstName: singleStudentData?.firstName,
        lastName: singleStudentData?.lastName,
        uniRollNo: singleStudentData?.uniRollNo || '',
        dob: dob ? moment(dob) : '',
        type: singleStudentData?.currentCourse?.admissionType,
        previous_college: singleStudentData?.currentCourse?.previousCollege,
        previous_university:
          singleStudentData?.currentCourse?.previousUniversity,
        degree: singleStudentData?.currentCourse?.degree,
        department: singleStudentData?.currentCourse?.department,
        specialisation: typeof singleStudentData?.currentCourse?.specialisation === 'string' && singleStudentData?.currentCourse?.specialisation !== '' ? singleStudentData?.currentCourse?.specialisation.split(',') : [],
        specialisationId: typeof singleStudentData?.currentCourse?.specialisationId === 'string' && singleStudentData?.currentCourse?.specialisationId !== '' ? singleStudentData?.currentCourse?.specialisationId.split(',') : [],
        specialisationData: specialisations,
        batch: singleStudentData?.currentCourse?.startedOn
          ? [
              moment(parseInt(singleStudentData?.currentCourse?.startedOn)),
              moment(parseInt(singleStudentData?.currentCourse?.endedOn)),
            ]
          : [],
        email: singleStudentData?.admin?.email,
        contactNumber:
          singleStudentData?.studentPersonalProfile?.phoneNumber?.split(' ')[1],
        noOfArrears: singleStudentData?.currentCourse?.noOfArrears,
        averageMarks: singleStudentData?.currentCourse?.averageMarks
          ? parseFloat(singleStudentData?.currentCourse?.averageMarks).toFixed(
              2
            )
          : parseFloat(0).toFixed(2),
        courseId: singleStudentData?.courseId,
        domainId: singleStudentData?.currentCourse?.domainId,
        domain: singleStudentData?.currentCourse?.domain,
        degreeId: singleStudentData?.currentCourse?.degreeId,
        streamId: singleStudentData?.currentCourse?.streamId,
        educationLevel: singleStudentData?.currentCourse?.educationLevel,
        degreeStreamMapId: singleStudentData?.currentCourse?.degreeStreamMapId,
        gender: singleStudentData?.studentPersonalProfile?.gender,
      })

      if (
        singleStudentData?.studentPersonalProfile?.dob &&
        !singleStudentData?.studentPersonalProfile?.dob?.includes('/')
      ) {
        dob = new Date(singleStudentData?.studentPersonalProfile?.dob)
        dob = `${dob.getDate()}/${dob?.getMonth() + 1}/${dob?.getFullYear()}`
      }
      setStudentDOB(dob)
    }
  }, [singleStudentData])

  const onEditStudent = id => {
    setCurrentStudentId(id)
    setIsEditingForm(true)
    setNewStudentDrawer(true)
    getSingleStudentData(id)
  }

  const closePopup = () => {
    setShowSuccessPopup(false)
    setEmailPopUp(false)
  }
  const onSubmitFormData = data => {
    let newDob = ''
    if (studentDOB?.includes('/')) {
      newDob = studentDOB?.split('/')
      setStudentDOB(`${newDob[2]}-${newDob[1]}-${newDob[0]}`)
      newDob = `${newDob[2]}-${
        newDob[1].length > 1 ? newDob[1] : '0' + newDob[1]
      }-${newDob[0].length > 1 ? newDob[0] : '0' + newDob[0]}`
    } else {
      newDob = studentDOB
    }
    let startedOn = studentBatch?.startedOn
    let endedOn = studentBatch?.endedOn
    if (isNaN(startedOn)) {
      if (!startedOn?.includes('-')) {
        startedOn = moment(parseInt(startedOn)).format('YYYY-MM')
      }
      if (!endedOn?.includes('-')) {
        endedOn = moment(parseInt(endedOn)).format('YYYY-MM')
      }
    } else {
      startedOn = moment(parseInt(startedOn)).format('YYYY-MM')
      endedOn = moment(parseInt(endedOn)).format('YYYY-MM')
    }
    const reqData = {
      admin: {
        email: data?.email?.trim(),
        phoneNumber: data?.contactNumber,
        firstName: data?.firstName.trim(),
        lastName: data?.lastName?.trim() || '',
        countryCode: countryCode?.replaceAll('+', ''),
        gender: data?.gender,
      },
      student: {
        uniRollNo: data?.uniRollNo,
        batch: `${startedOn}-${endedOn}`,
        instituteCampusName: instituteData?.campusName,
        courseId: data?.courseId,
        instituteCampusId: instituteData?.id,
      },
      studentPersonalProfile: {
        contactNumber: data?.contactNumber,
        isAnywhere: isEditingForm ? singleStudentData?.studentPersonalProfile?.isAnywhere : false,
      },
      currentCourse: {
        admissionType: data?.type,
        previousCollege:
          data?.type == 'transferred' ? data?.previous_college : null,
        previousUniversity:
          data?.type == 'transferred' ? data?.previous_university : null,
        degree: data?.degree,
        department: data?.department,
        degreeId: data?.degreeId,
        streamId: data?.streamId,
        domainId: data?.domainId,
        domain: data?.domain,
        examType: marksType?.examType,
        duration: marksType?.duration,
        educationLevel:
          data?.educationLevel?.toLowerCase() == 'p.g.diploma'
            ? 'p_g_diploma'
            : data?.educationLevel?.toLowerCase(),
      //  specialisation: data?.specialisation || '',
        startedOn: Date.parse(new Date(startedOn)),
        endedOn: Date.parse(new Date(endedOn)),
        averageMarks: data?.averageMarks ? parseFloat(data?.averageMarks).toFixed(2) : 0,
        degreeStreamMapId: data?.degreeStreamMapId,
        noOfArrears: Number(data?.noOfArrears),
        attendanceBacklisted: false,
        conductBacklisted: false,
        collegeFeeBacklisted: false,
        stateId: instituteData?.stateId,
        state: instituteData?.state,
        cityId: instituteData?.cityId,
        city: instituteData?.city,
        optOutStatus: isEditingForm
        ? singleStudentData?.currentCourse?.optOutStatus // or keep current value if editing
        : accessLevel === 1 || accessLevel === 3
          ? null
          : 3,
      },
      education: [],
      resume: {},
    }
    let payLoad = { ...reqData }
    if (studentDOB) {
      payLoad.admin.dob = newDob
      payLoad.studentPersonalProfile.dob = newDob
    } else {
      payLoad.admin.dob = null
      payLoad.studentPersonalProfile.dob = null
    }
    if (isEditingForm) {
      payLoad.isTPOUpdate = true
    }
    // if (specialization?.id) {
   // payLoad.currentCourse['specialisationId'] = specialization?.id || ''
    // }
if(specialization?.length){
payLoad.currentCourse['specialisationId'] = specialization?.map(item => item?.id).join(',') || ''
payLoad.currentCourse['specialisation'] = specialization?.map(item => item?.name).join(',') || ''
}else{
    payLoad.currentCourse['specialisationId'] = ''
    payLoad.currentCourse['specialisation'] = ''
}
    let newQuery
    const currentTabData = cardsData[cardNumber - 1]

    if (currentTabData) {
      newQuery = `pageLimit=10&pageNo=${currentPage}&${currentTabData?.filter}`
      setUrlQuery(`${currentTabData?.filter}`)
    } else {
      newQuery = `pageLimit=10&pageNo=${currentPage}`
    }
    if (isEditingForm) {
      editStudent(
        currentStudentId,
        payLoad,
        setNewStudentDrawer,
        onClearAll,
        newQuery
      )
      setBatchValue('') // Clear batchValue after the operation is finished
      setRangeValue('')
    } else {
      createStudent(
        payLoad,
        data?.courseId,
        eventId,
        setNewStudentDrawer,
        onClearAll
      )
      setBatchValue('')
      setCardNumber(null)
      setCheckHeaderData(false)
      setCardsData(defaultCardsData)
      setUrlQuery('')
      // cardsSetter()// Clear batchValue after the operation is finished
    }
  }

  const onClearAll = () => {
    createEditForm.resetFields()
    setIsEditingForm(false)
    setStudentType('')
    setCurrentStudentId('')
    setStudentDOB('')
    setStudentBatch({
      startedOn: '',
      endedOn: '',
    })
    setSearch('')
    setCountryCode('+91')
    // setUrlQuery()
    // setFilterData(true)
    setBatchValue('')
    setRangeValue('')
  }
  useEffect(() => {
    if (filterData) {
      let newQuery
      const currentTabData = cardsData[cardNumber - 1]

      if (currentTabData) {
        newQuery = `pageLimit=10&pageNo=${currentPage}&${currentTabData?.filter}`
        setUrlQuery(`${currentTabData?.filter}`)
      } else {
        newQuery = `pageLimit=10&pageNo=${currentPage}`
      }
    }
  }, [filterData, cardNumber, cardsData, currentPage])
  const applyCardFilter = query => {
    setCardNumber(query.key)
    let cardsDataCopy = [...cardsData]

    cardsDataCopy = cardsDataCopy.map(val => {
      if (query.filter === val.filter) {
        if (val.isSelected) {
          val.isSelected = false
          setUrlQuery(``)
          setNewUrlQuery(``)
          setCurrentPage(0)
        } else {
          val.isSelected = true
          setSelected('Opt-ed out students')
          setUrlQuery(`${query.filter}`)
          setNewUrlQuery(`${query.filter}`)
          setCurrentPage(0)
        }
      } else {
        val.isSelected = false
      }
      return val
    })

    const filterData = cardsDataCopy.find(item => item.isSelected === true)
    setCheckHeaderData(filterData)
    setCardsData(cardsDataCopy)
  }

  const onFilerChange = query => {
    // Reset to first page when filters change
    setCurrentPage(0);
    
    // If query is empty/null, we want to clear all filters but keep tab filters
    if (!query || query === '') {
      setUrlQuery(newUrlQuery || '')
      return
    }
    
    const selectedFilters = new URLSearchParams(query)
    const cardFilters = new URLSearchParams(newUrlQuery)

    // Degree is a roster filter, not an Active-student filter.  When it is
    // applied after an Active/Inactive card was selected, do not carry the
    // card's status into the request; that previously hid Pending and Invite
    // Sent students with the selected degree.  A Status chosen in the filter
    // itself remains in selectedFilters and is still sent.
    if (selectedFilters.has('degreeStreamMapIds')) {
      cardFilters.delete('status')
    }

    const cardQuery = cardFilters.toString()
    const combinedQuery =
      query && cardQuery
        ? `${cardQuery}&${query}`
        : query
        ? query
        : cardQuery

    const searchParams = new URLSearchParams(combinedQuery)

    const uniqueParams = new URLSearchParams()
    Array.from(searchParams.keys()).forEach(key => {
      uniqueParams.delete(key)
      uniqueParams.set(key, searchParams.get(key))
    })

    const newQueryString = uniqueParams.toString()
    setUrlQuery(newQueryString)
  }

  const onSortingChanged = query => {
    setSortQuery(query)
  }

  const permittedEvents = permittedEventCruds(permissions, 'STUDENTS')

  const cruds = permittedEvents?.map(permission =>
    permission?.events?.eventName?.toUpperCase()?.trim()
  )
  const addNewStudent =
    permittedEvents?.find(item => item.events?.eventName === 'NEW STUDENT')
      ?.events || ''

  const bulkUploadStudent =
    permittedEvents?.find(item => item.events?.eventName === 'BULK UPLOAD')
      ?.events || ''

  const resendInvite =
    permittedEvents?.find(item => item.events?.eventName === 'RESENT INVITE')
      ?.events || ''

  useEffect(() => {
    if (resendInvite?.id) getNotificationCatalogues(resendInvite?.id)
  }, [resendInvite])
  useEffect(() => {
    const filteredArray = notificationCatalogues?.CatalogueData?.filter(
      item =>
        item.eventNotificationTemplate &&
        item.eventNotificationTemplate.templateName === 'Deactive Student' &&
        item.eventNotificationTemplate.eventNotificationType &&
        item.eventNotificationTemplate.eventNotificationType.name === 'E-Mail'
    )

    if (filteredArray?.length > 0) {
      setMatchingTemplate(filteredArray[0].eventNotificationTemplate)
    }
  }, [notificationCatalogues])

  let resendDisabled 
  if(!selectAll){
   resendDisabled = (selectedStudents.length === 0 && !selectAll) ||
    cardNumber === 6 ||
    cardNumber === 7 ||
    cardNumber === 4 ||
    selectedUniqueStudents.length === 0 
  } else if(selectAll && selectedUniqueStudents.length === 0){ 
    resendDisabled = false
  } else{
    resendDisabled = selectedUniqueStudents.length === 0 ||
    cardNumber === 6 ||
    cardNumber === 7 ||
    cardNumber === 4
  }
   
  const menu = (
    <Menu
      items={[
        {
          key: '1',
          label: 'Bulk Upload',
          disabled: !cruds?.includes('NEW STUDENT'),
          onClick: () => {
            setUploadDrawer(true)
          },
        },
        {
          key: '1a',
          label: 'Upload Status',
          disabled: !cruds?.includes('NEW STUDENT'),
          onClick: () => {
            setStatusDrawer(true)
          },
        },
        {
          key: '2',
          label: 'Delete',
          // disabled: !selectedStudents?.length && !cruds?.includes('DELETE'),
          disabled: selectedStudents?.length === 0,
          onClick: () => {
            showConfirm()
          },
        },
      ]}
    />
  )
  const ScrollRef = () => {
    object.current.scrollIntoView({ behavior: 'smooth' })
  }

  const handleSelectAll = () => {
    setSelectAll(true)
    setSelectedStudents(studentsList?.data?.result?.map(student => student.id))
  }

  const handleClearAll = () => {
    setSelectAll(false)
    setSelectedStudents([])
    setSelectedUniqueStudents([])
  }

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [modalContent, setModalContent] = useState({ text: '', actionType: '' })

  const handleResendClick = () => {
    setModalContent({
      text: `Are you sure to resend invite for these ${
        selectAll ? studentsList?.data?.inactiveCount : selectedUniqueStudents.length
      } students?`,
      actionType: 'resend',
    })
    setIsModalVisible(true)
    setEmailPopUp(false);
  }

  const handleDeleteClick = () => {
    setModalContent({
      text: `Are you sure to delete these ${
        selectAll ? studentsList?.selectAllCount : selectedStudents.length
      } students?`,
      actionType: 'delete',
    })
    setIsModalVisible(true)
  }

  const handleCloseModal = () => {
    setIsModalVisible(false)
  }
  const handleConfirmAction = async () => {
    if (modalContent.actionType === 'resend') {
      let payload = {
        forAllStudents: selectAll,
        studentIds: selectedStudents,
        instituteCampusId: instituteId,
        filteredRoleIds: filteredRoleIds,
      }
      let res = await bulkReInviteStudent(payload)
      if (res?.status === 200) {
        setIsModalVisible(false)
        setShowSuccessPopup(true)
        setSelectAll(false)
        setSelectedStudents([])
        setSelectedUniqueStudents([])
      }

      // setUploadDrawer(true)
    }
    // else if (modalContent.actionType === 'delete') {
    //   setIsEditingForm(false)
    //   setNewStudentDrawer(true)
    //   setEventId(addNewStudent?.id)
    // }
    setIsModalVisible(false)
  }
  const handleApprove = async () => {
    setSelectAll(false)
    setPopUp(false)
    let payload = {
      email: userData.email,
      instName: instituteDetails.campusName,
      state: instituteDetails.state,
      city: instituteDetails.city,
      user: userData.first_name + ' ' + userData.last_name,
      studentIds: selectAll === true ? studentListId : [selectedStudents],
    }
    if (payload.studentIds[0].length > 5) {
      setEmailPopUp(true)
      setShowSuccessPopup(true)
    }
    setBulkDownload(false)
    setSelectedStudents([])
    setSelectedUniqueStudents([])
    setStudentListId([])
    const response = await resumeBulkDownload(payload)
    if (response?.data) {
      if (payload.studentIds[0].length === 1) {
        const studentData = studentsList?.data?.result.filter(
          p => p.id === payload.studentIds[0][0]
        )
        const studentName =
          studentData[0]?.firstName + ' ' + studentData[0]?.lastName
        await singlePdf(response, studentName,studentData[0]?.id)
      } else if (payload.studentIds[0].length <= 5) {
        await zipFile(response.data)
      }
    }
  }
  const handleClosePopup = () => {
    setBulkDownload(false)
    setPopUp(false)
  }

  return (
    <>
      <SectionWrapper column>
        <div ref={object}></div>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading flexStart>Manage Students</TopHeading>
          {addNewStudent && (
            <TopRightFlex>
              <Button.Secondary
                height={'38px'}
                text={'Bulk Upload'}
                onClick={() => {
                  setUploadDrawer(true)
                }}
              />
              <Button.Secondary
                height={'38px'}
                text={'Upload Status'}
                onClick={() => {
                  setStatusDrawer(true)
                }}
              />
              <Button.Primary
                height={'38px'}
                text={'New Student'}
                icon={<PlusIcon />}
                onClick={() => {
                  setIsEditingForm(false)
                  setNewStudentDrawer(true)
                  setEventId(addNewStudent?.id)
                }}
              />

              {/* <Dropdown overlay={menu}>
                <SmallButtons height={'38px'} icon={<VerticalThreeDots />} />
              </Dropdown> */}
            </TopRightFlex>
          )}
        </TopHeader>
        <CardRow>
          {cardsData?.map(card => (
            <InfoCards
              key={card?.key}
              width={'140px'}
              icon={card?.icon}
              text={card?.text}
              value={card?.value}
              background={
                card?.isSelected ? COLORS.BLUE_T_50 : COLORS.BLUE_T_95
              }
              isSelected={card?.isSelected}
              onClick={() => {
                applyCardFilter(card)
                setSelectedStudents([])
                setSearch('')
                setBatchValue([])
                setSelectAll(false)
                setSelectedUniqueStudents([])
              }}
            />
          ))}
        </CardRow>
        {/* <div style={{ padding: '0px 20px 20px 0px ' }}>
         
             
            
  
        </div> */}

        <ActionBarWrapper>
          <div>
            {cardNumber !== 6 &&
              cardNumber !== 7 &&
              selectedStudents.length > 0 && (
                <SelectAllFlex>
                  <div style={{ fontSize: '13px', padding: '0px 20px' }}>
                    {`Selected `}
                    <span style={{ fontWeight: 800 }}>
                      {`${
                        selectAll
                          ? studentsList?.data?.count
                          : selectedStudents?.length
                      } ${
                        (selectAll ? studentsList?.data?.count : selectedStudents?.length) > 1 ? 'students' : 'student'
                      }`}
                    </span>
                    {selectAll ? ` from all pages` : ` from this page`}
                  </div>

                  {/* Show "Select all X students from all pages" button when not all selected */}
                  {!selectAll && studentsList?.data?.count > 10 && (
                    <Button.Primary
                      onClick={handleSelectAll}
                      text={
                        <>
                          {`Select all `}
                          <span style={{ fontWeight: 800 }}>
                            {`${studentsList?.data?.count} ${
                              studentsList?.data?.count > 1
                                ? 'students'
                                : 'student'
                            }`}
                          </span>
                          {` from all pages`}
                        </>
                      }
                      fontsize={'0.8rem'}
                      style={{ marginLeft: '10px' }}
                    />
                  )}

                  {/* Show "Clear Selection" button when all students are selected */}
                  {selectAll && (
                    <Button.Primary
                      onClick={handleClearAll}
                      text="Clear Selection"
                      fontsize={'0.8rem'}
                      style={{ marginLeft: '10px' }}
                    />
                  )}
                </SelectAllFlex>
              )}
          </div>
        </ActionBarWrapper>

        <StudentsInfoTable
          cardsData={cardNumber}
          search={search}
          setSearch={setSearch}
          ScrollRef={ScrollRef}
          studentsList={studentsList}
          getSingleStudentData={getSingleStudentData}
          deleteStudent={deleteStudent}
          singleStudentData={singleStudentData}
          onEditStudent={onEditStudent}
          blacklistStudent={blacklistStudent}
          activeInactivateStatus={activeInactivateStatus}
          setUrl={onFilerChange}
          currentUrl={urlQuery}
          setUrlQuery={setUrlQuery}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          degreeList={degreeList}
          setSelectedStudents={setSelectedStudents}
          selectedStudents={selectedStudents}
          reInviteStudent={reInviteStudent}
          eventId={resendInvite?.id}
          onSortValueChanged={onSortingChanged}
          loading={loading}
          cruds={cruds}
          matchingTemplate={matchingTemplate}
          sendNotificationEmail={sendNotificationEmail}
          counter={counter}
          setCounter={setCounter}
          checkHeaderData={checkHeaderData}
          SelectUnRestricted={SelectUnRestricted}
          SelectBlacklist={SelectBlacklist}
          instituteCampusId={instituteCampusId}
          getStudentsListData={getStudentsListData}
          getConsentDrawerList={getConsentDrawerList}
          filterData={filterData}
          setFilterData={setFilterData}
          batchValue={batchValue}
          setBatchValue={setBatchValue}
          cardsDetails={cardsData}
          rangeValue={rangeValue}
          setRangeValue={setRangeValue}
          getJobRolePreview={getJobRolePreview}
          getStudentPlacedList={getStudentPlacedList}
          getPlacementHistoryList={getPlacementHistoryList}
          getPreview={getPreview}
          selectAll={selectAll}
          setSelectAll={setSelectAll}
          selectedUniqueStudents={selectedUniqueStudents}
          setSelectedUniqueStudents={setSelectedUniqueStudents}
          tabs={tabs}
          setTabsData={setTabsData}
          SelectOptOutlist={SelectOptOutlist}
          tabsData={tabsData}
          resendDisabled={resendDisabled}
          handleResendClick={handleResendClick}
          setBulkDownload={setBulkDownload}
          setPopUp={setPopUp}
          setNewUrlQuery={setNewUrlQuery}
          setCheckHeaderData={setCheckHeaderData}
          selected={selected}
          setSelected={setSelected}
          checkedDegreeData={checkedDegreeData}
          setCheckedDegreeData={setCheckedDegreeData}
        />
      </SectionWrapper>

      {newStudentDrawer && (
        <AddNewStudentDrawer
          newStudentDrawer={newStudentDrawer}
          setNewStudentDrawer={setNewStudentDrawer}
          form={createEditForm}
          degreeList={degreeList}
          onSubmitFormData={onSubmitFormData}
          studentType={studentType}
          setStudentType={setStudentType}
          studentDOB={studentDOB}
          setStudentDOB={setStudentDOB}
          studentBatch={studentBatch}
          setStudentBatch={setStudentBatch}
          marksType={marksType}
          setMarksType={setMarksType}
          setSpecialization={setSpecialization}
          specialization={specialization}
          title={isEditingForm ? 'Edit & Update Student' : 'Add New Student'}
          isEditingForm={isEditingForm}
          onEditFullProfile={handleEditFullProfile}
          sendButtonText={isEditingForm ? 'Update Student' : 'Add Student'}
          formId={isEditingForm ? 'edit_form' : 'add_form'}
          dateFormat={dateFormat}
          onClearAll={onClearAll}
          countryCode={countryCode}
          setCountryCode={setCountryCode}
          singleStudentData={singleStudentData}
          setCourseId={setCourseId}
          courseId={courseId}
          gender={gender}
          setGender={setGender}
        />
      )}

      <SettingsDrawer
        settingDrawer={settingDrawer}
        setSettingDrawer={setSettingDrawer}
      />
      {(uploadDrawer || statusDrawer) && (
        <StudentsBulkUpload
          uploadDrawer={uploadDrawer}
          setUploadDrawer={setUploadDrawer}
          statusDrawer={statusDrawer}
          setStatusDrawer={setStatusDrawer}
          degreeList={degreeList}
          setSelectedStudents={setSelectedStudents}
          bulkUploadStudents={bulkUploadStudents}
          eventId={bulkUploadStudent?.id}
          getStudentsListData={getStudentsListData}
        />
      )}
      {isModalVisible && (
        <ConfirmationModal onClose={handleCloseModal}>
          <ShortListModalImg>
            <img
              src={
                modalContent.actionType === 'delete'
                  ? deleteIcon
                  : duplicateIcon
              }
              alt={modalContent.actionType}
              style={{ width: '200px', height: '200px' }}
            />
          </ShortListModalImg>
          <ModalText>{modalContent.text}</ModalText>
          <ButtonDiv>
            <Button.Secondary
              text="Back"
              onClick={handleCloseModal}
              width={'120px'}
              height={'38px'}
            />
            <Button.Primary
              text="Send"
              onClick={handleConfirmAction}
              width={'120px'}
              height={'38px'}
            />
          </ButtonDiv>
        </ConfirmationModal>
      )}
      <SucessfullPopup
        description={
          emailPopUp ? (
            <div>
              Your request is being processed. Please check your email inbox
              shortly for the download link.
            </div>
          ) : (
            <div>Invite Sent</div>
          )
        }
        Icon={SuccessIcon}
        showDrawer={showSuccessPopup}
        setShowDrawer={setShowSuccessPopup}
        onCloseClick={closePopup}
      />
      <CloseRoleDrawer
        description="Are you sure you want to download all selected resumes?"
        Icon={PopUpPageIcon}
        showDrawer={popUp}
        setShowDrawer={setPopUp}
        onCloseClick={handleClosePopup}
        onApprove={handleApprove}
        closeText="No"
        YesText="Yes"
        closeButtonHeight="38px"
        closeButtonWidth="80px"
        yesButtonHeight="38px"
        yesButtonWidth="105px"
      />
    </>
  )
}
export default Students
